/*
 * Special View for handling the Contents and Content pages, and switching between them without distroying each other
 */

define([
  "marionette",
  "jquery",
  "modules/contentsSplit/template/contentsSplitTemplate.html",
], function (Marionette, $, ContentsSplitTemplate) {
  var ContentsSplitView = {};

  ContentsSplitView.contentsSplitLayout = Marionette.Layout.extend({
    template: ContentsSplitTemplate,
    regions: {
      contentsRegion: "#contentsRegion",
      contentRegion: "#contentRegion",
    },
    hideContent: function () {
      $("#contentRegion").hide();
      //also reset the region, since we could be playing a video and that would continue in the background
      //(plus we always load the content page from scratch)
      this.contentRegion.reset();
    },
    hideContents: function () {
      $("#contentsRegion").hide();
    },
    showContent: function () {
      $("#contentRegion").show();
    },
    showContents: function () {
      $("#contentsRegion").show();
    },
  });

  return ContentsSplitView;
});
